export function isStateSameOrParent(currentPathName, nextPathName) {
  return currentPathName && currentPathName.indexOf(nextPathName) === 0;
}

export function linkClassNamesObj(routerStateCurrent, routerState, isDisabled) {
  return {
    active: isStateSameOrParent(routerStateCurrent, routerState),
    disabled: isDisabled,
  };
}
